import axios from "axios";
import { SELFCARE_API_PATH } from "../../../../config/configs";
import {
  getBasePathOfSelfcare,
  getGsid,
} from "../../../../utils/utils";
import { getCsrfToken } from "./csurfServiceSelfcare";

const apiServiceSelfcare = axios.create({
  baseURL: SELFCARE_API_PATH,
  withCredentials: true,
});

// Add a request interceptor
apiServiceSelfcare.interceptors.request.use(
  async (config) => {
    const method = config.method?.toUpperCase();
    const g = getGsid();
    if (g !== undefined && g !== ""){
      config.headers["GSID"] = g;
    }
    

    if (
      ["POST", "PUT", "PATCH", "DELETE"].includes(method as string) &&
      config.url !== "/csurf/token" &&
      config.url !== "/log/event"
    ) {
      const csrfToken = await getCsrfToken();
      config.headers["X-CSRF-Token"] = csrfToken;
    }

    // Add GSID to headers
    

    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
apiServiceSelfcare.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Handle authentication errors (401 Unauthorized or 403 Forbidden)
      if (error.response.status === 401 || error.response.status === 403) {
        // Clear authentication data
        localStorage.removeItem("selfcareAuth");

        // Get the current path
        const currentPath = window.location.pathname;

        // Only redirect if not already on the login page
        if (!currentPath.includes("/login")) {
          // Store the current location for potential redirect after login
          const returnUrl = window.location.pathname + window.location.search;
          sessionStorage.setItem("returnUrl", returnUrl);

          // Get base path and construct login URL
          const basePath = getBasePathOfSelfcare();
          const loginPath = `${basePath}/login`;

          // Redirect to login using relative path
          window.location.href = loginPath;
        }
      }
      error = {
        status: error.response.status,
        message: error.response.data?.message ?? error.response.data,
        ...error,
      }
      console.error("Error response:", error);
    } else {
      console.error("Error message:", error.message);
    }
    return Promise.reject(error);
  }
);

export default apiServiceSelfcare;
